module.exports = __webpack_public_path__ + "static/img/sharefriend425dcc6.jpg";